import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ZoomOutIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 14L14.71 14L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3S3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71L14 15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14ZM7 9L12 9L12 10L7 10L7 9Z"
      fill="currentColor"
    />
  </svg>
);

ZoomOutIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ZoomOutIcon);
